import { ReactNode } from 'react';
import { RenderIf } from 'react-rainbow-components';
import Badge from 'components/Badge';
import UserAvatar from 'components/UserAvatar';
import {
    PatientBadges,
    PatientButton,
    PatientDetails,
    PatientInfo,
    PatientName,
    PatientNameRow,
} from './styled';

interface PatientItemProps {
    name: string;
    firstName?: string;
    lastName?: string;
    details?: string;
    inactive?: boolean;
    badge?: ReactNode;
    isSelected?: boolean;
    onClick: () => void;
}

const PatientItem = ({
    name,
    firstName,
    lastName,
    details,
    inactive,
    badge,
    isSelected,
    onClick,
}: PatientItemProps) => {
    const initials = [firstName, lastName]
        .map((value) => value?.[0])
        .filter(Boolean)
        .join('')
        .toUpperCase();

    return (
        <PatientButton type="button" isSelected={isSelected} onClick={onClick}>
            <UserAvatar value={name} initials={initials} />
            <PatientInfo>
                <PatientNameRow>
                    <PatientName>{name}</PatientName>
                    <PatientBadges>
                        <RenderIf isTrue={inactive}>
                            <Badge label="Inactive" variant="default" size="small" />
                        </RenderIf>
                        {badge}
                    </PatientBadges>
                </PatientNameRow>
                <RenderIf isTrue={details}>
                    <PatientDetails>{details}</PatientDetails>
                </RenderIf>
            </PatientInfo>
        </PatientButton>
    );
};

export default PatientItem;
